import ChartJS from "chart.js/auto";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useHistory, useParams } from "react-router-dom";

// Icons
import { BsChevronLeft, BsChevronRight, BsHouseFill } from "react-icons/bs";
import { FiPaperclip } from "react-icons/fi";
import checkGreenIcon from "~/assets/icons/check-green.svg";
import closeRedIcon from "~/assets/icons/close-red.svg";
import mcfBuildHhouse from "~/assets/img/mcf-build-house.png";
import mcfBoxInsta from "~/assets/img/mfc-box-insta.png";
import mfcBoxMail from "~/assets/img/mfc-box-mail.png";
import mfcBoxWhatsUp from "~/assets/img/mfc-box-whatsup.png";

// Types
import type { IChatCompletions, IUserPrompt, TPromptRoles } from "~/services/openAI/types";
import type { IStudyProps, TSlidersID } from "./types";

// Modesl
import type { IMBatche } from "~/models/Batche";
import type { IMRealStateProduct } from "~/models/RealEstateProduct";
import type { IMRealEstateProductHomeOptions } from "~/models/RealEstateProductHomeOption";
import type { IMRealEstateProductsHouse } from "~/models/RealEstateProductHouse";

// Hooks
import { useAuthContext } from "~/hooks/contexts/Auth";

// Services
import api from "~/services/api";
import { AIGPT } from "~/services/openAI";

// Styles
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { IoPrint } from "react-icons/io5";
import { MdArrowBack } from "react-icons/md";
import { debounce } from "~/utils/debounce";
import { getCondomminiuMaturity } from "../utils/functions";
import { Steps } from "./Partials/Steps";
import './styles.css';

export function Study(_props: IStudyProps) {
    const { user } = useAuthContext()
    const [slider, setSlider] = useState<TSlidersID>(1)
    const [batches, setBatches] = useState<IMBatche[]>([])
    const [batchesCompletions, setBatchesCompletions] = useState<IChatCompletions | null>(null)
    const [locationCompletions, setLocationCompletions] = useState<IChatCompletions | null>(null)
    const [clientCompletions, setClientCompletions] = useState<IChatCompletions | null>(null)

    // AUX Variables
    const PDF_STATEMENT = useMemo(() => new jsPDF({
        orientation: 'portrait',
        unit: 'pt',
        format: 'a4',
        compress: true
    }),[])
    const MAIN_CONTAINER_TO_PRINT = useRef<HTMLDivElement>()

    const handlerToPDF =  useCallback(() => {
        try {
            const ELEMENT_MAIN = document.querySelector('#teste-teste') as HTMLElement

            // console.table(ELEMENT_MAIN)

            const BUTTON_ACT_PRINT = document.querySelector('#button-action-print') as HTMLButtonElement
            PDF_STATEMENT.html(ELEMENT_MAIN, {
                x: 50,
                y: 50,
                autoPaging: true,
                filename:'minha_proposta',
                callback(doc) {
                    doc.save('minha_proposta')
                },
            })


            // BUTTON_ACT_PRINT.setAttribute('hidden', 'true')
            // html2canvas(ELEMENT_MAIN, {
            //     allowTaint: true,
            //     useCORS: true,
            //     logging: true,
            // }).then(canvas => {
            //     const CANVAS_URL_DATA = canvas.toDataURL("image/png",1);
            //     const CANVAS_LINK_TO_DOWNLOAD = document.createElement('a');

            //     CANVAS_LINK_TO_DOWNLOAD.setAttribute('download','minha_proposta.png');

            //     CANVAS_LINK_TO_DOWNLOAD.setAttribute('href', CANVAS_URL_DATA);

            //     CANVAS_LINK_TO_DOWNLOAD.click();

            //     CANVAS_LINK_TO_DOWNLOAD.remove();

            //     BUTTON_ACT_PRINT.removeAttribute('hidden')
            //     // canvas.toBlob((blobs) => {
            //     // }, "application/pdf",1);

            //     // PDF_STATEMENT.html(canvas, {
            //     //     autoPaging: false,
            //     //     image: {
            //     //         quality: 1,
            //     //         type: 'png'
            //     //     }
            //     // })

            //     // const CANVAS_LINK_TO_DOWNLOAD = document.createElement('a');

            //     // CANVAS_LINK_TO_DOWNLOAD.setAttribute('download','minha_proposta.png');
            //     // CANVAS_LINK_TO_DOWNLOAD.setAttribute('href', CANVAS_URL_DATA);

            //     // CANVAS_LINK_TO_DOWNLOAD.click();

            //     // CANVAS_LINK_TO_DOWNLOAD.remove();

            //     // PDF_STATEMENT.save('minha_proposta.pdf')
            // })

            // html2pdf().set({
            //     margin: 0,
            //     image: { type: 'jpeg', quality: 0.98 },
            //     jsPDF: {
            //         orientation: 'p',
            //         unit: 'pt',
            //         format: 'a4',
            //         putOnlyUsedFonts: true,
            //         floatPrecision: 16 // or "smart", default is 16
            //     }
            // }).from(ELEMENT_MAIN).toPdf().save('teste')

        } catch (error) {

        }
    },[PDF_STATEMENT])

    const PARAMS = useParams<{ id: string }>()
    const history = useHistory()
    const USER_PROMPT = (user?.name || `${new Date().getTime()}`).split(' ').join('-').toLocaleLowerCase()
    const PROMPT_ORIGIN = 'rep-study-views'
    const REP_PROJECT: IMRealStateProduct | null = JSON.parse(sessionStorage.getItem('REP@PROJECT') || '{}') || null
    const REP_BUILD_DATA: {
        houseAmount: number
        idealArea: number
        idealAreaBuild: number,
        AMOUNT_BY_METERS: string,
        VGV: {
            [key: number]: {
                vgv: number;
                house_area: number;
                terrain_area: number;
            }[];
        }
    } | null = JSON.parse(sessionStorage.getItem('REP@BUILD_DATA') || '{}') || null

    const REP_HOUSES: IMRealEstateProductsHouse[] | null = JSON.parse(sessionStorage.getItem('REP@HOUSES') || '{}') || null

    const PROJECT_MAD = getCondomminiuMaturity(REP_PROJECT)

    const AI_STATEMENT = useMemo(() => new AIGPT(user, null, [], PROMPT_ORIGIN, 'gpt-3.5-turbo'), [user])

    const VGV_RANGE: { quantity: string, label: string, labelRaw: number }[] = useMemo(() => {
        const VGV_RANGE: any[] = []
        Object.keys(REP_BUILD_DATA?.VGV || {}).forEach(key => {
            VGV_RANGE.push({
                label: Intl.NumberFormat('pt-BR', {
                    style: 'currency',
                    currency: 'BRL',
                }).format(key as unknown as number),
                labelRaw: key as unknown as number,
                quantity: `${REP_BUILD_DATA?.VGV[key as unknown as number].length || 0}`
            })
        })

        // for(let i=0; i < D.length; i++) {

        //     if(i + 1 > D.length) break;

        //     for(let j=i+1; j <= D.length - 1; j++ ){

        //         if(D[i].labelRaw > D[j].labelRaw ){
        //             const k = D[i]
        //             const w = D[j]

        //             D[j] = k
        //             D[i] = w
        //         }
        //     }
        // }

        return VGV_RANGE
    }, [])

    const VGV_IN_TEXT = VGV_RANGE.map((d, i) => {
        if ((i + 1) <= VGV_RANGE.length && (d.quantity > '1' && (VGV_RANGE[i + 1] && d.quantity >= VGV_RANGE[i + 1]?.quantity) || d.quantity === VGV_RANGE[i - 1]?.quantity)) return d;
    }).map(d => d?.label || '').filter(d => d.trim() !== '').join(', ')

    const VGV_RANGE_FIRST_AMOUNT = VGV_IN_TEXT.split(', ')[0]
    const VGV_RANGE_LAST_AMOUNT = VGV_IN_TEXT.split(', ')[VGV_IN_TEXT.split(', ').length - 1]

    const VGV_RANGE_FIRST_AMOUNT_RAW = Number.parseFloat(VGV_IN_TEXT.split(', ')[0].split('R$ ')[0])
    const VGV_RANGE_LAST_AMOUNT_RAW = Number.parseFloat(VGV_IN_TEXT.split(', ')[VGV_IN_TEXT.split(', ').length - 1].split('R$ ')[0])

    const HOUSES_TOTAL = useMemo(() => REP_HOUSES?.length || 0, [REP_HOUSES])
    const HOUSE_AREA_BUILD = useMemo(() => Math.round(REP_HOUSES?.reduce((d, v) => v.terrain_area + d, 0) || 0), [REP_HOUSES])
    const HOUSE_AREA = useMemo(() => REP_HOUSES?.reduce((d, v) => v.house_area + d, 0) || 0, [REP_HOUSES])
    const X = useMemo(() => {
        const BY = 20
        const AREA_BY = Math.round(HOUSE_AREA_BUILD / BY)
        const AREAS_LIST: number[] = []
        let AREA_ACCUMULETED = 0

        Array(AREA_BY).fill(null).forEach((d, i) => {
            // if(AREA_ACCUMULETED === HOUSE_AREA_BUILD) return;

            AREAS_LIST.push(AREA_ACCUMULETED)

            AREA_ACCUMULETED += BY

        })

        return AREAS_LIST
    }, [HOUSE_AREA_BUILD])
    const Y = useMemo(() => {
        const BY = 50
        const AREA_BY = Math.round(HOUSE_AREA / BY)
        const AREAS_LIST: number[] = []
        let AREA_ACCUMULETED = 0

        Array(AREA_BY).fill(null).forEach((d, i) => {
            // if(AREA_ACCUMULETED === HOUSE_AREA_BUILD) return;

            AREAS_LIST.push(AREA_ACCUMULETED)

            AREA_ACCUMULETED += BY

        })

        return AREAS_LIST
    }, [HOUSE_AREA])
    // ÀREA DA  CONSTRUÇÃO
    // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
        const HOUSES_IN_AREA_BUILD = useMemo(() => {
        const T: {
            [index: string]: {
                houses: ((IMRealEstateProductsHouse | null))[]
                count: number
                rangeRaw: number[]
            }
        } = {}

        for (let i = 0; i < X.length; i++) {
            const NEXT = i + 1
            let HOUSES_COUNT = 0

            if (!X?.[NEXT]) break;

            for (let g = 0; g <= HOUSES_TOTAL; g++) {
                const HOUSE_AREA_BUILD = REP_HOUSES?.[g]?.terrain_area || 0

                if (HOUSE_AREA_BUILD > X[i] && HOUSE_AREA_BUILD <= X[NEXT]) {
                    HOUSES_COUNT++

                    if (!T[`${X[i]}_${X[NEXT]}`]) {
                        T[`${X[i]}_${X[NEXT]}`] = {
                            houses: [REP_HOUSES?.[g] || null],
                            count: HOUSES_COUNT,
                            rangeRaw: [X[i], X[NEXT]]
                        }
                    } else {
                        T[`${X[i]}_${X[NEXT]}`]['count'] = HOUSES_COUNT
                        T[`${X[i]}_${X[NEXT]}`]['houses'].push(REP_HOUSES?.[g] || null)
                    }
                }
            }
        }

        // console.log(X)
        // console.log(T)

        return T
    }, [X, HOUSES_TOTAL])
    // ÀREA CONSTRUIDA DA  CASA
    // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
        const HOUSES_IN_AREA = useMemo(() => {
        const T: {
            [index: string]: {
                houses: ((IMRealEstateProductsHouse | null))[]
                count: number
                rangeRaw: number[]
            }
        } = {}

        for (let i = 0; i < Y.length; i++) {
            const NEXT = i + 1
            let HOUSES_COUNT = 0

            if (!Y?.[NEXT]) break;

            for (let g = 0; g <= HOUSES_TOTAL; g++) {
                const HOUSE_AREA = REP_HOUSES?.[g]?.house_area || 0

                if (HOUSE_AREA > Y[i] && HOUSE_AREA <= Y[NEXT]) {
                    HOUSES_COUNT++

                    if (!T[`${Y[i]}_${Y[NEXT]}`]) {
                        T[`${Y[i]}_${Y[NEXT]}`] = {
                            houses: [REP_HOUSES?.[g] || null],
                            count: HOUSES_COUNT,
                            rangeRaw: [Y[i], Y[NEXT]]
                        }
                    } else {
                        T[`${Y[i]}_${Y[NEXT]}`]['count'] = HOUSES_COUNT
                        T[`${Y[i]}_${Y[NEXT]}`]['houses'].push(REP_HOUSES?.[g] || null)
                    }
                }
            }
        }

        // console.log(X)
        // console.log(T)

        return T
    }, [Y, HOUSES_TOTAL])

    const OPTIONS = useMemo(() => {
        if (!REP_PROJECT || REP_PROJECT!.houses!.length <= 0) return;

        const optionsInMount: IMRealEstateProductHomeOptions[] = []

        for (let i = 0; i < REP_PROJECT!.houses!.length; i++) {
            // @ts-ignore
            for (let j = 0; j < REP_PROJECT!.houses[i]!.home_options!.length; j++) {
                // @ts-ignore
                let homeOption = REP_PROJECT!.houses[i]!.home_options[j];

                if (optionsInMount.find(optionMount => optionMount.option === homeOption.option || optionMount.id === homeOption.id)) continue;

                optionsInMount.push(homeOption);
            }
        }

        return optionsInMount
    }, [REP_PROJECT])


    // console.log(HOUSES_IN_AREA_BUILD)

    async function handlerSetToExternal(dataToStorage: IUserPrompt | null = null, chatCompletions: IChatCompletions, repID = -1) {
        try {
            const P_TARGET = 0

            if (dataToStorage && chatCompletions) {
                // FILTER BY CONTEXT TYPE AND FORCE ONLY ARRAY OF LENGHT 1
                dataToStorage['prompts'] = [
                    (dataToStorage?.prompts.filter(p => p.origin.toString() === PROMPT_ORIGIN))?.[0] || []
                ]

                // It maybe that the local store time is different from the runtime for these functions
                // That is why it is necessary to perform a forced update on the array of choices
                dataToStorage['choices'] = [...chatCompletions.choices, ...dataToStorage['choices']]
            }

            await AI_STATEMENT.setOnExternalChatData(dataToStorage, P_TARGET, repID)
        } catch (error) {
            // do anything
        }
    }

    function getBatches() {
        try {
            api.get<IMBatche[]>(`builders/real-estate-products/${PARAMS?.id || -1}/terrains`).then((resolver) => {
                if (resolver.status !== 200) return;

                setBatches(resolver.data)

                getBatchesCompletions(resolver.data)
            })
        } catch (error) {
            // do anything
        }
    }

    async function getBatchesCompletions(batcheList: IMBatche[] = []) {
        try {
            if (!batcheList || batcheList.length <= 0) return;
            if (batchesCompletions) return;

            const PROMPTS = [
                // @ts-ignore
                ...batcheList.map((b, index) => ({
                    name: USER_PROMPT,
                    role: 'system' as TPromptRoles,
                    content: `${index + 1}ª - Lote (${b.name}), com uma área de ${b.area}m² de ${Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(b.amount)} por ${Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(b.square_meter)}/m²`
                })),
                {
                    name: USER_PROMPT,
                    // @ts-ignore
                    role: 'system',
                    content: 'Do(s) lote(s) informado(s) acima, e considerando o preço de lote por m², qual demonstra ser a melhor opção? Informe o nome do lote e explique por que ele é a melhor opção'
                }
            ]

            AI_STATEMENT.set('localyType', PROMPT_ORIGIN)

            // @ts-ignore
            AI_STATEMENT.set('prompts', PROMPTS)

            console.log(PROMPTS, batcheList)

            // @ts-ignore
            const COMPLETIONS_RESPONSE = await AI_STATEMENT.onChatStream(PROMPTS, null, () => ({}), () => ({}), false)
            const USER_DATA_STORAGED = AI_STATEMENT.getChatCompletionsStoraged()?.[user?.unique_id || '']

            await AI_STATEMENT.setChatStreamDataToStorage(COMPLETIONS_RESPONSE)
            await handlerSetToExternal(USER_DATA_STORAGED, COMPLETIONS_RESPONSE, REP_PROJECT?.id)

            setBatchesCompletions(COMPLETIONS_RESPONSE)
        } catch (error) {
            // do anything
        }
    }

    async function getLocationCompletions() {
        try {
            if (locationCompletions) return;

            const PROMPTS = [
                {
                    name: USER_PROMPT,
                    // @ts-ignore
                    role: 'system' as TPromptRoles,
                    content: `Qual é a capital do estado do endereço: ${REP_PROJECT?.localization || ''}, e qual é o tempo e distancia de viagem`
                }
            ]

            AI_STATEMENT.set('localyType', 'rep-study-views-location')

            AI_STATEMENT.set('prompts', PROMPTS)

            console.log(PROMPTS, locationCompletions)

            // @ts-ignore
            const COMPLETIONS_RESPONSE = await AI_STATEMENT.onChatStream(PROMPTS, null, () => ({}), () => ({}), false)
            const USER_DATA_STORAGED = AI_STATEMENT.getChatCompletionsStoraged()?.[user?.unique_id || '']

            await AI_STATEMENT.setChatStreamDataToStorage(COMPLETIONS_RESPONSE)
            await handlerSetToExternal(USER_DATA_STORAGED, COMPLETIONS_RESPONSE, REP_PROJECT?.id)

            setLocationCompletions(COMPLETIONS_RESPONSE)
        } catch (error) {
            // do anything
        }
    }

    async function getClientCompletions() {
        try {
            if (clientCompletions) return;

            const PROMPTS = [
                {
                    name: USER_PROMPT,
                    // @ts-ignore
                    role: 'system',
                    content: `Quais são os requisitos mais importantes para quem procura um imóvel de lazer em ${REP_PROJECT?.localization || ''}?, faça um breve resumo`
                }
            ]

            AI_STATEMENT.set('localyType', PROMPT_ORIGIN + "-" + "client-profile")

            // @ts-ignore
            AI_STATEMENT.set('prompts', PROMPTS)

            // @ts-ignore
            const COMPLETIONS_RESPONSE = await AI_STATEMENT.onChatStream(PROMPTS, null, () => ({}), () => ({}), false)

            const USER_DATA_STORAGED = AI_STATEMENT.getChatCompletionsStoraged()?.[user?.unique_id || '']
            const P_TARGET = 0

            if (USER_DATA_STORAGED) {
                // FILTER BY CONTEXT TYPE AND FORCE ONLY ARRAY OF LENGHT 1
                USER_DATA_STORAGED['prompts'] = [
                    (USER_DATA_STORAGED?.prompts.filter(p => p.origin.toString() === PROMPT_ORIGIN))?.[0] || []
                ]

                // It may be that the local store time is different from the runtime for these functions
                // That is why it is necessary to perform a forced update on the array of choices
                USER_DATA_STORAGED['choices'] = [...COMPLETIONS_RESPONSE.choices, ...USER_DATA_STORAGED['choices']]
            }

            // console.table({d: USER_DATA_STORAGED?.['prompts']})

            await AI_STATEMENT.setChatStreamDataToStorage(COMPLETIONS_RESPONSE)
            await AI_STATEMENT.setOnExternalChatData(USER_DATA_STORAGED, P_TARGET, REP_PROJECT?.id)

            setClientCompletions(COMPLETIONS_RESPONSE)
        } catch (error) {
            // do anything
        }
    }

    function printPage() {
        try {
             const ELEMENT_MAIN = document.querySelector('#printable') as HTMLElement

             window.print()
        } catch (error) {

        }
    }

    // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
    const handlerOnKeyboardEvent = useCallback((code: string = '', actualSlider = -1) => {
        try {
            if (!code) throw new Error('');

            switch (code) {
                case 'ArrowDown':
                    actualSlider > 1 && setSlider(actualSlider - 1 as TSlidersID)
                    break;
                case 'ArrowLeft':
                    actualSlider > 1 && setSlider(actualSlider - 1 as TSlidersID)
                    break;
                case 'ArrowUp':
                    (actualSlider >= 1 && actualSlider < 16) && setSlider(actualSlider + 1 as TSlidersID)
                    break;
                case 'ArrowRight':
                    console.log(actualSlider < 16, actualSlider)
                    actualSlider < 16 && setSlider(actualSlider + 1 as TSlidersID)
                    break;
                default:
                // do anything
            }
        } catch (error) {
            // do anythig
        }
    }, [slider])

    // MAKE THE CHARTS RENDER
    // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
        useEffect(() => {
        const CHART_CONTAINER_PROPERTY_VGV = document.querySelector("#property-amount") as HTMLCanvasElement
        const CHART_CONTAINER_PROPERTY_AREA = document.querySelector("#property-area") as HTMLCanvasElement
        const CHART_CONTAINER_PROPERTY_AREA_BUILD = document.querySelector("#property-area-build") as HTMLCanvasElement
        const CHART_CONTAINER_PROPERTY_AMOUNT_AREA = document.querySelector("#property-amount-area") as HTMLCanvasElement

        if (!CHART_CONTAINER_PROPERTY_AREA || !CHART_CONTAINER_PROPERTY_VGV) return;

        const CHART_STATEMENT_PROPERTY_VGV = new ChartJS(CHART_CONTAINER_PROPERTY_VGV, {
            type: 'bar',
            data: {
                // labels: Object.keys(REP_BUILD_DATA?.VGV || {}).map(k => k),
                datasets: [{
                    label: 'QUANTIDADES DE UNIDADES',
                    backgroundColor: '#079269',
                    borderRadius: 11.5,
                    hoverBackgroundColor: '#a3d3c5',
                    data: VGV_RANGE
                }]
            },
            options: {
                parsing: {
                    xAxisKey: 'label',
                    yAxisKey: 'quantity',
                }
            }
        })

        const CHART_STATEMENT_PROPERTY_AREA = new ChartJS(CHART_CONTAINER_PROPERTY_AREA, {
            type: 'bar',
            data: {
                labels: REP_HOUSES?.map((d, i) => d.name),
                datasets: [{
                    label: 'ÀREA CONSTRUIDA (m²)',
                    backgroundColor: '#079269',
                    borderRadius: 11.5,
                    hoverBackgroundColor: '#a3d3c5',
                    data: REP_HOUSES?.map((d, i) => d.house_area) || []
                }]
            },
            options: {
                parsing: {
                    // xAxisKey: 'label',
                    yAxisKey: 'quantity',
                }
            }
        })

        const CHART_STATEMENT_PROPERTY_AREA_BUILD = new ChartJS(CHART_CONTAINER_PROPERTY_AREA_BUILD, {
            type: 'bar',
            data: {
                labels: REP_HOUSES?.map((d, i) => `${d.name}`),
                datasets: [{
                    label: 'ÀREA DO TERRENO (m²)',
                    backgroundColor: '#079269',
                    borderRadius: 11.5,
                    hoverBackgroundColor: '#a3d3c5',
                    data: REP_HOUSES?.map((d, i) => d.terrain_area) || []
                }]
            },
            options: {
                plugins: {
                    title: {
                        text: 'Casa'
                    },
                }
            }
        })

        const CHART_STATEMENT_PROPERTY_AMOUNT_AREA = new ChartJS(CHART_CONTAINER_PROPERTY_AMOUNT_AREA, {
            data: {
                labels: REP_HOUSES?.map((d, i) => `${d.name}`),
                datasets: [{
                    type: 'bar',
                    label: 'AT (m²)',
                    backgroundColor: '#079269',
                    borderRadius: 11.5,
                    hoverBackgroundColor: '#afebda',
                    data: REP_HOUSES?.map((d, i) => d.terrain_area) || []
                },
                {
                    type: 'bar',
                    label: 'AC (m²)',
                    backgroundColor: '#a3d3c5',
                    borderRadius: 11.5,
                    hoverBackgroundColor: '#daf1ea',
                    data: REP_HOUSES?.map((d, i) => d.house_area) || []
                },
                ]
            },
            options: {
                plugins: {
                    title: {
                        text: 'Casa'
                    },
                }
            }
        })

        return () => {
            CHART_STATEMENT_PROPERTY_VGV.destroy();
            CHART_STATEMENT_PROPERTY_AREA.destroy();
            CHART_STATEMENT_PROPERTY_AREA_BUILD.destroy();
            CHART_STATEMENT_PROPERTY_AMOUNT_AREA.destroy();
        }
    }, [])

    // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
    useEffect(() => {
        getBatches()
        getClientCompletions()
        getLocationCompletions()
    }, [])

    // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
    useEffect(() => {
        if (document) {
            document.addEventListener('keydown', (event) => debounce(1, handlerOnKeyboardEvent, event.code, slider))
        }

        return () => {
            document.removeEventListener('keydown', (event) => debounce(1, handlerOnKeyboardEvent, event.code, slider))
        }
    }, [slider])

    return (
        <div id="printable" className="md:ml-[106px] h-screen  relative overflow-hidden print:!flex print:!flex-col print:!w-full page-break print:!m-0"
            style={{
                width: 'calc(100vw - 106px)',
            }}
        >
            {/* <button
                type="button"
                id="button-action-print"
                onClick={() => handlerToPDF()}
                title="Imprir documento"
                className="w-12 h-12
                    fixed right-24 bottom-24
                    rounded-full
                    bg-[#20b174]
                    flex
                    items-center justify-center flex-row
                    transition-all duration-[0.37s]
                    shadow-md
                    scale-100
                    hover:scale-110
                    active:bg-[#1e8359]
                    print:hidden
                    z-[999]
                "
            >
                <IoPrint color="#ffff" size={24}/>
            </button> */}

            <span
                role="button"
                onClick={() => setSlider(old => (old === 1 ? old : old - 1) as TSlidersID)}
                data-first={slider === 1}
                id="left-bar-navigation"
                className="
                    absolute
                    w-1/6
                    h-screen
                    px-4
                    z-[-1]
                    pointer-events-none
                    top-0
                    left-0
                    flex flex-row
                    flex-nowrap
                    items-center justify-center
                    gap-4
                    cursor-default
                    select-none
                    data-[first=true]:bg-black/0
                    data-[first=false]:hover:bg-black/20
                    data-[first=false]:cursor-pointer
                    data-[first=false]:z-50
                    data-[first=false]:pointer-events-auto
                    transition-colors
                    duration-[0.15s]
                    print:hidden
                "
            >
                <BsChevronLeft
                    data-first={slider === 1}
                    size={64}
                    className="chevron-left
                        text-white/20
                        transition-colors
                        duration-[0.12s] hidden
                    "
                />
            </span>

            <span
                role="button"
                onClick={() => setSlider(old => (old + 1) as TSlidersID)}
                data-last={slider === 15}
                id="right-bar-navigation"
                className="absolute
                    w-1/6
                    h-screen
                    px-4
                    z-[-1]
                    pointer-events-none
                    cursor-default
                    top-0
                    right-0
                    flex flex-row
                    flex-nowrap
                    items-center justify-center
                    gap-4
                    data-[last=true]:bg-black/0
                    data-[last=false]:hover:bg-black/20
                    data-[last=false]:cursor-pointer
                    data-[last=false]:z-[900]
                    data-[last=false]:pointer-events-auto
                    transition-colors
                    duration-[0.15s]
                    print:hidden
                "
            >
                <BsChevronRight
                    data-last={slider === 16}
                    size={64}
                    className="chevron-right text-white hidden"
                />
            </span>

            <span data-first={slider === 1} className="absolute  print:!relative  px-4 w-full
                    z-[999] h-auto bottom-5
                    flex flex-row flex-nowrap items-center justify-center
                    gap-2
                    print:!hidden
                "
            >
                 <span
                    title="Voltar"
                    role="button"
                    onClick={() => history.goBack()}
                    className="
                        w-[42px]
                        h-[42px]
                        hover:opacity-20

                        rounded-full
                        border-[1px]
                        border-slate-200
                        bg-slate-100
                        font-bold
                        text-black
                        text-xl
                        flex flex-row
                        flex-flex-nowrap
                        items-center justify-center

                        transition-all
                        duration-[0.15s]
                    "
                >
                    <MdArrowBack />
                </span>
                {
                    Array(15).fill(null).map((_d, i) => (
                        <span
                            data-slided={(i + 1) === slider}
                            title={`${i + 1}ª Slider`}
                            role="button"
                            key={i}
                            className="
                                w-[18px] h-[18px]

                                data-[slided=false]:opacity-50
                                data-[slided=true]:w-[32px]
                                data-[slided=true]:h-[32px]
                                data-[slided=false]:hover:opacity-20
                                data-[slided=false]:hover:w-[32px]
                                data-[slided=false]:hover:h-[32px]
                                data-[slided=false]:hover:text-xs

                                rounded-full
                                border-[1px]
                                border-slate-200 bg-slate-100
                                font-bold text-black text-[10px]
                                flex flex-row
                                flex-flex-nowrap
                                items-center justify-center

                                select-none

                                transition-all
                                duration-[0.15s]
                            "
                            onClick={() => debounce(50, setSlider, (i + 1))}
                        >
                            {i + 1}
                        </span>
                    ))
                }
            </span>

            <Steps.Apresentation ation REP_PROJECT={REP_PROJECT} infocusID={slider} />

            <Steps.Location REP_PROJECT={REP_PROJECT} infocusID={slider} locationCompletions={locationCompletions} />

            <Steps.Characteristcs REP_PROJECT={REP_PROJECT} infocusID={slider} />

            <Steps.Profile REP_PROJECT={REP_PROJECT} infocusID={slider} clientCompletions={clientCompletions} />

            <Steps.VGV VGV_IN_TEXT={VGV_IN_TEXT} infocusID={slider} />

            <Steps.PredominantBPArea HOUSES_IN_AREA_BUILD={HOUSES_IN_AREA_BUILD} infocusID={slider} />

            <Steps.PredominantLandArea HOUSES_IN_AREA={HOUSES_IN_AREA}  infocusID={slider} />

            <Steps.Chart infocusID={slider} />

            <Steps.Batches REP_BUILD_DATA={REP_BUILD_DATA} infocusID={slider} batches={batches} />

            <Steps.Indicators REP_BUILD_DATA={REP_BUILD_DATA} infocusID={slider} batches={batches} VGV_RANGE_FIRST_AMOUNT_RAW={VGV_RANGE_FIRST_AMOUNT_RAW} VGV_RANGE_LAST_AMOUNT_RAW={VGV_RANGE_LAST_AMOUNT_RAW} />

            <Steps.IdealHouse OPTIONS={OPTIONS} REP_BUILD_DATA={REP_BUILD_DATA} REP_PROJECT={REP_PROJECT} infocusID={slider} />

            <Steps.IdealHouseCompare OPTIONS={OPTIONS} REP_PROJECT={REP_PROJECT} infocusID={slider} />

            <Steps.IdealTerrain infocusID={slider} batches={batches} batchesCompletions={batchesCompletions} />

            <Steps.Resume
                REP_BUILD_DATA={REP_BUILD_DATA}
                infocusID={slider}
                VGV_IN_TEXT={VGV_IN_TEXT}
            />


            <div data-infocusID={slider === 15} className="absolute print:!relative opacity-100  -left-[100%] data-[inFocusID=true]:opacity-0   data-[inFocusID=true]:left-0 transition-all duration-[0.38s] border-[1px] border-r-[#000] last-of-type:border-none w-full h-screen flex flex-col justify-between gap-4 p-16 bg-[#079269]">
                <div className="w-full flex flex-row flex-nowrap items-center justify-end gap-4">
                    <span className="flex w-16">
                        <img src={mcfBuildHhouse} alt="Icone com silueta de uma casa" className="max-w-full h-auto" />
                    </span>
                </div>

                <div className="w-full flex flex-col  gap-8">
                    <span className="flex w-full flex-row flex-nowrap items-center gap-4">
                        <span className="w-12">
                            <img src={mfcBoxMail} alt="Icone generico" className="max-w-full h-auto" />
                        </span>
                        <span className="text-white font-semibold text-xl">
                            {
                                user?.construtech?.email || 'N/A'
                            }
                        </span>
                    </span>
                    <span className="flex w-full flex-row flex-nowrap items-center gap-4">
                        <span className="w-12">
                            <img src={mcfBoxInsta} alt="Icone generico" className="max-w-full h-auto" />
                        </span>
                        <span className="text-white font-semibold text-xl">
                            {
                                user?.engenheiro?.social_works?.instagram || 'N/A'
                            }
                        </span>
                    </span>
                    <span className="flex w-full flex-row flex-nowrap items-center gap-4">
                        <span className="w-12">
                            <img src={mfcBoxWhatsUp} alt="Icone generico" className="max-w-full h-auto" />
                        </span>
                        <span className="text-white font-semibold text-xl">
                            {
                                user?.construtech?.telefone || 'N/A'
                            }
                        </span>
                    </span>
                    <span className="flex w-full flex-row flex-nowrap items-center gap-4">
                        <FiPaperclip size={32} className="text-white" />
                        <span className="text-white font-semibold text-xl ml-4">
                            {
                                user?.construtech?.site || 'N/A'
                            }
                        </span>
                    </span>
                </div>
            </div>
        </div>
    )
}
